import { RouteInfo } from '../vertical-menu/vertical-menu.metadata';

export const HROUTES: RouteInfo[] = [

  new RouteInfo('/app', 'Page', 'ft-home'),

//   {
//     path: '', title: 'Menu Levels', icon: 'ft-align-left', cssClass: 'dropdown nav-item has-sub', badge: '', badgeClass: '', isExternalLink: false, order: 1,
//     submenu: [
//         { path: '/YOUR-ROUTE-PATH', title: 'Second Level', icon: 'ft-arrow-right submenu-icon', cssClass: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, order: 0, submenu: [] },
//         {
//             path: '', title: 'Second Level Child', icon: 'ft-arrow-right submenu-icon', cssClass: 'has-sub', badge: '', badgeClass: '', isExternalLink: false, order: 1,
//             submenu: [
//                 { path: '/YOUR-ROUTE-PATH', title: 'Third Level 1.1', icon: 'ft-arrow-right submenu-icon', cssClass: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, order: 0, submenu: [] },
//                 { path: '/YOUR-ROUTE-PATH', title: 'Third Level 1.2', icon: 'ft-arrow-right submenu-icon', cssClass: 'dropdown-item', badge: '', badgeClass: '', isExternalLink: false, order: 1, submenu: [] },
//             ]
//         },
//     ]
// },
];
